// Default parameters for different generation types
export interface BaseParams {
  content_to_adapt: string;
  preferred_color: string;
  do_save: boolean;
}

export interface HeroParams extends BaseParams {
  adapt_slightly: boolean;
  do_front: boolean;
  use_custom_prompt?: boolean;
  custom_prompt?: string;
}

export interface ImageParams extends BaseParams {
  adapt_slightly: boolean;
  do_front: boolean;
  do_some: boolean;
  use_custom_prompt?: boolean;
  custom_prompt?: string;
}

export interface GeminiParams extends BaseParams {
  adapt_slightly?: boolean;
  do_front?: boolean;
  do_some?: boolean;
  use_custom_prompt?: boolean;
  custom_prompt?: string;
}

export type GenerationParams = {
  hero: HeroParams;
  image: ImageParams;
  gemini: GeminiParams;
}

export const DEFAULT_PARAMS: GenerationParams = {
  hero: {
    content_to_adapt: '',
    preferred_color: '',
    adapt_slightly: true,
    do_front: false,
    do_save: true
  },
  image: {
    content_to_adapt: '',
    preferred_color: '',
    adapt_slightly: true,
    do_some: false,
    do_front: false,
    do_save: true
  },
  gemini: {
    content_to_adapt: '',
    preferred_color: '',
    do_save: true
  }
};

// Available images for selection in the debug interface
export const DEFAULT_IMAGES = [
  '/hero-about.png',
  '/hero-candidates.png',
  '/hero-company.png',
  '/hero-startseite.png',
  '/section-requirements.png',
  '/section-active-search.png',
  '/section-matching.png',
  '/section-coaching.png',
  '/section-cooperation.png'
];

// Tab definitions for the debug interface
export interface DebugTab {
  id: string;
  label: string;
}

export const DEBUG_TABS: DebugTab[] = [
  { id: 'generation', label: 'Generation' },
  { id: 'prompts', label: 'Prompts' },
  { id: 'history', label: 'History' },
  { id: 'advanced', label: 'Advanced' }
];